<template>
    <b-tooltip
      :label="
        $t('adminQuestion.translation') +
          languages[0] +
          ' -> ' +
          choosenLanguage
"
    >
      <div
        style="margin-left:10px; margin-top:5px; cursor:pointer;"
        @click="translate()"
        :disabled="languages[0] === choosenLanguage"
      >
        <img class="icon" style="padding:3px;" src="@/assets/img/icons/translation-icon.png"  alt="icon-translation" />
      </div>
    </b-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      languages: [],
      choosenLanguage: '',
      languageOrigin: '',
      updatedArray: [],
      emptyStringToTranslate: false
    }
  },
  props: {
    entitledQuestion: String,
    entitledQuestionEn: String,
    entitledQuestionEs: String,
    entitledQuestionDe: String,
    questionAnswers: Array,
    indexSection: Number,
    indexQuestion: Number
  },
  computed: {
    ...mapGetters(['languageQuestionAdmin', 'selectedCountryLanguage'])
  },
  watch: {
    selectedCountryLanguage () {
      this.languageTranslation()
    },
    languageQuestionAdmin () {
      this.languageTranslation()
    }
  },
  created () {
    this.languageTranslation()
  },
  methods: {
    languageTranslation () {
      this.emptyStringToTranslate = false
      this.languages = []
      // pre translations with $i18n
      let french = this.$i18n.t('language.french')
      let english = this.$i18n.t('language.english')
      let spanish = this.$i18n.t('language.spanish')
      let deutsch = this.$i18n.t('language.deutsch')
      let firstPush = ''
      switch (this.$store.state.langage.langue) {
        case 'fr':
          firstPush = french
          this.languageOrigin = 'fr'
          break
        case 'en':
          firstPush = english
          this.languageOrigin = 'en'
          break
        case 'es':
          firstPush = spanish
          this.languageOrigin = 'es'
          break
        case 'de':
          firstPush = deutsch
          this.languageOrigin = 'de'
          break
      }
      // get the first item language chosen
      let arrayLanguagesTemporary = this.$store.getters.sondage_languages
      if (arrayLanguagesTemporary.includes(this.$store.state.langage.langue)) {
        if (arrayLanguagesTemporary.length === 1) {
          this.$store.commit(
            'UPDATE_ARRAY_LANGUAGES',
            this.$store.getters.sondage_languages
          )
        } else {
          let orderedArrayLanguages = arrayLanguagesTemporary.filter(
            language => language !== this.$store.state.langage.langue
          )
          orderedArrayLanguages.unshift(this.$store.state.langage.langue)
          this.$store.commit('UPDATE_ARRAY_LANGUAGES', orderedArrayLanguages)
        }
      } else {
        this.$store.commit(
          'UPDATE_ARRAY_LANGUAGES',
          this.$store.getters.sondage_languages
        )
      }
      // translation array survey
      for (let i = 0; i < this.$store.getters.sondage_languages.length; i++) {
        if (this.$store.getters.sondage_languages.includes(this.languageOrigin)) {
          this.languages.push(firstPush)
        } else {
          switch (this.$store.getters.sondage_languages[0]) {
            case 'fr':
              this.languageOrigin = 'fr'
              this.languages.push(this.$i18n.t('language.french'))
              break
            case 'en':
              this.languageOrigin = 'en'
              this.languages.push(this.$i18n.t('language.english'))
              break
            case 'es':
              this.languageOrigin = 'es'
              this.languages.push(this.$i18n.t('language.spanish'))
              break
            case 'de':
              this.languageOrigin = 'de'
              this.languages.push(this.$i18n.t('language.deutsch'))
              break
          }
        }
        if (
          this.languageQuestionAdmin !== 'fr' &&
          this.$store.getters.sondage_languages[i] === 'fr'
        ) {
          this.languages.push(french)
        }
        if (
          this.languageQuestionAdmin !== 'en' &&
          this.$store.getters.sondage_languages[i] === 'en'
        ) {
          this.languages.push(english)
        }
        if (
          this.languageQuestionAdmin !== 'es' &&
          this.$store.getters.sondage_languages[i] === 'es'
        ) {
          this.languages.push(spanish)
        }
        if (
          this.languageQuestionAdmin !== 'de' &&
          this.$store.getters.sondage_languages[i] === 'de'
        ) {
          this.languages.push(deutsch)
        }
      }
      // choosen translation
      switch (this.selectedCountryLanguage) {
        case 'fr':
          this.choosenLanguage = french
          break
        case 'en':
          this.choosenLanguage = english
          break
        case 'es':
          this.choosenLanguage = spanish
          break
        case 'de':
          this.choosenLanguage = deutsch
          break
      }
    },
    translate () {
      let stringToTranslate = ''
      if (this.languageOrigin === 'fr') {
        if (stringToTranslate === '') {
          stringToTranslate = this.entitledQuestion
          this.questionAnswers.forEach(
            answer => {
              if (answer.entitled !== undefined || answer.entitled !== '') { (stringToTranslate = stringToTranslate + `&text=` + answer.entitled) } else { this.emptyStringToTranslate = true }
            }
          )
        } else {
          this.emptyStringToTranslate = true
        }
      } if (this.languageOrigin === 'en') {
        if (stringToTranslate === '') {
          stringToTranslate = this.entitledQuestionEn
          this.questionAnswers.forEach(
            answer => {
              if (answer.entitled !== undefined || answer.entitled_en !== '') { (stringToTranslate = stringToTranslate + `&text=` + answer.entitled_en) } else { this.emptyStringToTranslate = true }
            }
          )
        } else {
          this.emptyStringToTranslate = true
        }
      } if (this.languageOrigin === 'es') {
        if (stringToTranslate === '') {
          stringToTranslate = this.entitledQuestionEs
          this.questionAnswers.forEach(
            answer => {
              if (answer.entitled !== undefined || answer.entitled_es !== '') { (stringToTranslate = stringToTranslate + `&text=` + answer.entitled_es) } else { this.emptyStringToTranslate = true }
            }
          )
        } else {
          this.emptyStringToTranslate = true
        }
      } if (this.languageOrigin === 'de') {
        if (stringToTranslate === '') {
          stringToTranslate = this.entitledQuestionDe
          this.questionAnswers.forEach(
            answer => {
              if (answer.entitled !== undefined || answer.entitled_de !== '') { (stringToTranslate = stringToTranslate + `&text=` + answer.entitled_de) } else { this.emptyStringToTranslate = true }
            }
          )
        } else {
          this.emptyStringToTranslate = true
        }
      }
      if (!this.emptyStringToTranslate) {
        this.$store.dispatch('getTranslation', {
          languageToTranslate: this.$store.getters.languageQuestionAdmin,
          languageOrigin: this.languageOrigin,
          stringToTranslate: stringToTranslate,
          indexQuestion: this.indexQuestion,
          indexSection: this.indexSection,
          questions: this.$store.state.question.questions,
          sections: this.$store.state.question.sections
        })
      } else {
        this.$buefy.toast.open({
          type: 'is-danger',
          position: 'is-top',
          message: this.$i18n.t('toast.question.emptyStringToTranslate')
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/components/ButtonTranslation.vue